module.exports = __webpack_public_path__ + "img/information-message.107ca25.svg";